import RewardsClients from '../const/clients';
var isTjx = function (clientId) {
    if (!clientId)
        return false;
    return clientId === RewardsClients.tjx;
};
export default isTjx;
